<div class="routes bg-white px-3">
    <div
        class="min-h-14 grid cursor-pointer grid-cols-[minmax(12%,auto)_1fr_10%] items-center gap-x-1 border-b border-solid border-zinc-200 py-2 last:border-none dark:border-contrast-yellow"
        *ngFor="let route of displayRoutes; trackBy: trackById"
        (click)="redirectToRouteDetails(route)">
        <rwidget-route-short-name
            [label]="route.shortName"
            [color]="staticColor || getColor(route)"
            [textColor]="getTextColor(route)"
            [shape]="ShapeType.ROUNDED"></rwidget-route-short-name>
        <div class="route-title text-base font-normal leading-5 text-black dark:text-contrast-yellow">
            {{ route.longName }}
        </div>
        <div class="text-center dark:filter-yellow">
            <img [src]="(assetsPath$ | async) + '/img/explore/arrow-right.svg'" alt="Arrow Right" />
        </div>
    </div>
</div>
